import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../GroupBarChart/GroupBarChart.css";

const GroupBarChart = () => {
  const options = {
    chart: {
      type: "column",
      backgroundColor: "#f8f8f7"
    },
    xAxis: {
      categories: [
        "Company A",
        "Company B",
        "Company C",
        "Company D",
        "Company F",
      ],
      title: {
        text: "Companies",
        align: "low",
        x: 0,
        y: 5,
        style: {
          color: "#999", // Set the color for the axis title
          fontSize: "16px", // Updated font size
        },
      },
      labels: {
        style: {
          color: "#999", // Set the color for the axis labels
          fontSize: "16px", // Updated font size
        },
      },
      lineWidth: 1,
      lineColor: "#999",
    },
    yAxis: {
      min: 10,
      max: 100,
      title: {
        text: "Performance Metrics",
        align: "high",
        rotation: 90,
        x: -10,
        y: 322,
        style: {
          color: "#999", // Set the color for the axis title
          fontSize: "16px", // Updated font size
        },
      },
      labels: {
        style: {
          color: "#999", // Set the color for the axis labels
          fontSize: "16px", // Updated font size
        },
      },
      lineWidth: 1,
      lineColor: "#999",
    },
    series: [
      {
        name: "Compliance",
        data: [55, 85, 92, 70, 49],
        color: "#a5bcfc",
      },
      {
        name: "Quality",
        data: [81, 35, 89, 91, 76],
        color: "#dcdcdc",
      },
      {
        name: "Delivery",
        data: [75, 60, 40, 50, 40],
        color: "#c7d7fe",
      },
    ],
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      style: {
        color: "#999",    // Tooltip text color
        fontSize: "16px", // Tooltip text font size
      },
    },
  };

  return (
    <>
      <section className="section">
        <div className="full-container">
          <div className="full-groupbar-header">
            <h1>
              Company Performance Overview
              {/* Compliance, Quality, and Delivery Metrics */}
            </h1>
          </div>

          <div className="full-groupbar-parent">
            <div className="full-groupbar-container">
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            <div className="full-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#a5bcfc" }}
                      ></i>
                    </td>
                    <td>Compliance</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#dcdcdc" }}
                      ></i>
                    </td>
                    <td>Quality</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#c7d7fe" }}
                      ></i>
                    </td>
                    <td>Delivery</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GroupBarChart;
